/*
 * premierstreets
 * version 4.5
 * http://www.premierstreets.com
 *
 * Copyright (c) 2021 premier streets
 * Author premier streets <support@premierstreets.com>
 * Licensed under the MIT license.
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Api } from '../providers/api/api';

@Injectable()
export class PostService extends Api {

    private base: string = this.getBaseUrl();


    /* get post detail api*/
    public listPost(params: any): Observable<any> {
        return this.http.get(this.base + `user-post/list`, { params });
    }


    /* create post api*/
    public createPost(params: any): Observable<any> {
        return this.http.post(this.base + 'user-post/create', params);
    }

    /* create product post api*/
    public createProductPost(params: any): Observable<any> {
        return this.http.post(this.base + 'user-post/add-product', params);
    }

    /* create vendor post api*/
    public createVendorPost(params: any): Observable<any> {
        return this.http.post(this.base + 'user-post/add-vendor', params);
    }

    /* create vendor post api*/
    public shareUrl(params: any): Observable<any> {
        return this.http.post(this.base + 'user-post/share-email', params);
    }

    /* create post like api*/
    public likePost(params: any): Observable<any> {
        return this.http.post(this.base + 'user-post/like', params);
    }

    /* create post like api*/
    public removeLike(params: any): Observable<any> {
        return this.http.post(this.base + 'user-post/remove-like', params);
    }

    /* create post tag api*/
    public addTag(params: any): Observable<any> {
        return this.http.post(this.base + 'user-post/add-tag', params);
    }

    /* create comment api*/
    public createComment(params: any): Observable<any> {
        return this.http.post(this.base + 'user-post/add-comment', params);
    }

    /* update post api*/
    public updatePost(params: any): Observable<any> {
        return this.http.post(this.base + `user-post/update/${params.id}`, params);
    }

    /* create vendor post api*/
    public shareChatUrl(params: any): Observable<any> {
        console.log("share chat url");
        console.log(params);
        return this.http.post(this.base + 'user-post/share-chat-email', params);
    }

    /* get post detail api*/
    public viewPost(params: any): Observable<any> {
        return this.http.get(this.base + `user-post/view/${params.id}`);
    }

    /* delete post api*/
    public deletePost(params: any): Observable<any> {
        return this.http.post(this.base + 'user-post/delete', params);
    }

    /* send friend request api*/
    public inviteFriends(params: any): Observable<any> {
        return this.http.post(this.base + 'user-content/invite', params);
    }

    /* send friend request api*/
    public sendFriendRequest(params: any): Observable<any> {
        return this.http.post(this.base + 'user-friend/create', params);
    }

    /* get friend list api*/
    public getFriends(params: any): Observable<any> {
        return this.http.get(this.base + 'user-friend/list', { params });
    }

    /* get friend list api*/
    public hasFriend(params: any): Observable<any> {
        return this.http.get(this.base + 'user-friend/exists', { params });
    }

    /* get friend list api*/
    public isOnline(params: any): Observable<any> {
        return this.http.get(this.base + 'user-friend/is-online', { params });
    }


}


